import axios from 'axios';
import toastMessage from './toast';

axios.defaults.baseURL = process.env.REACT_APP_BACKEND_URL;

axios.interceptors.request.use(
  (config) => {
    const keys = localStorage.getItem('izya_auth');
    if (keys) {
      try {
        const parsed = JSON.parse(keys);
        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${parsed?.access?.token}`,
          Accept: 'application/json'
        };
        if (!(config.data instanceof FormData)) {
          config.headers['Content-Type'] = 'application/json';
        } else {
          delete config.headers['Content-Type'];
        }
      } catch (error) {
        localStorage.removeItem('izya_auth');
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('izya_auth');
      toastMessage('Session expirée, veuillez vous reconnecter.', 'error');
      window.location.replace('/signin');
    }
    return Promise.reject(error);
  }
);

export default axios;
